import React from 'react';
import Dates from './Date';
import Date from './Date';
import Input from './Input';
import Select from './Select';
import SelectOfLang from './SelectOfLang';
import SelectWithApi from './SelectWithApi';
import TextArea from './TextArea';


const FormikControl = (props) => {
  const {control, ...rest} = props
    
  switch (control) {
      case 'input': return <Input {...rest} />

      case 'textarea': return <TextArea {...rest} />

      case 'select': return <Select {...rest} />

      case 'selectWithApi': return <SelectWithApi {...rest} />

      case 'selectOfLang': return <SelectOfLang {...rest} />

      // case 'asyncSelectCall': return <AsyncSelectCall {...rest} />

      // case 'upload': return <Upload {...rest} />

      // case 'radio': return <Radio {...rest} />

      // case 'checkbox':
      
      //     break;

      case 'date': return <Dates {...rest} />

      default:
          return null
  }
}


export default FormikControl;
